'use client'

import type { JSX } from "react";
import { openCookieSettings } from '@/lib/analytics'

export function CookieSettingsLink(): JSX.Element {
  return (
    <button
      type="button"
      onClick={openCookieSettings}
      className="hover:text-white transition-colors duration-200"
    >
      Cookie settings
    </button>
  )
}
